<template>
  <div class="error-container">
    <div class="vcore_container pe_container">
      <div class="vcore_row">
        <div class="vcore_col--xs--12 form-container_provider-logo">
          <LogoDisplay v-if="logo" :logo-src="logo"></LogoDisplay>
        </div>
        <div class="vcore_col--xs--12">
          <h2 class="form-title" tabindex="-1" v-focus="lastActivated">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              preserveAspectRatio="xMidYMid"
              width="48"
              height="48"
              viewBox="0 0 48 48"
            >
              <path
                d="M24.000,47.999 C10.767,47.999 -0.000,37.233 -0.000,24.000 C-0.000,10.766 10.767,-0.000 24.000,-0.000 C37.233,-0.000 48.000,10.766 48.000,24.000 C48.000,37.233 37.233,47.999 24.000,47.999 ZM24.000,2.000 C11.869,2.000 2.000,11.868 2.000,24.000 C2.000,36.131 11.869,45.999 24.000,45.999 C36.131,45.999 46.000,36.131 46.000,24.000 C46.000,11.868 36.131,2.000 24.000,2.000 ZM24.000,38.999 C22.897,38.999 22.000,38.102 22.000,37.000 C22.000,35.897 22.897,34.999 24.000,34.999 C25.102,34.999 26.000,35.897 26.000,37.000 C26.000,38.102 25.102,38.999 24.000,38.999 ZM24.000,31.999 C23.447,31.999 23.000,31.552 23.000,31.000 L23.000,13.000 C23.000,12.448 23.447,12.000 24.000,12.000 C24.553,12.000 25.000,12.448 25.000,13.000 L25.000,31.000 C25.000,31.552 24.553,31.999 24.000,31.999 Z"
              />
            </svg>
            Something went wrong.
          </h2>
          <div class="form-description">
            <p>
              We’re sorry. Something went wrong and we weren’t able to continue
              processing your enrollment.
            </p>
            <p>
              Please try again, or contact your Provider to enroll in HSF<span
                class="sup"
                >&reg;</span
              >
              <a
                class="phone-number vcore_link"
                v-if="selectedProvider"
                :href="`tel:${selectedProvider.billingContactPhone}`"
                >{{ selectedProvider.billingContactPhone }}</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LogoDisplay from "../LogoDisplay";
import { KEYS, getCustomBrandingByKey } from "@Shared/utils/CustomBranding";
import { mapGetters } from "vuex";

export default {
  name: "FormError",
  data() {
    return {
      lastActivated: "",
    };
  },
  components: {
    LogoDisplay,
  },
  activated() {
    this.lastActivated = +new Date();
  },
  computed: {
    ...mapGetters(["selectedProvider"]),
    logo() {
      return getCustomBrandingByKey(
        KEYS.LOGO,
        this.selectedProvider.customBrandingList
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.sup {
  font-size: 70%;
  vertical-align: super;
}
.form-title {
  svg {
    fill: $color_red;
    fill-rule: evenodd;
    height: 30px;
    width: 30px;
    vertical-align: middle;
    margin-bottom: 5px;
  }
}

.form-description {
  margin-top: 30px;

  p + p {
    margin-top: 20px;
  }

  .phone-number {
  }
}
</style>
